<template>
  <div>
    <slot v-if="loaded" />
  </div>
</template>

<script>
import store from '@/store/store';
import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';

export default {
  name: 'storeRechercheProvider',
  props: {
    name: {
      type: String,
      required: true,
    },
    copy: {
      type: Object,
      required: true,
    },
    copyChanges: {
      type: Object,
      default() {
        return {};
      },
    },
    isTemporary: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loaded: false,
    };
  },
  methods: {
    handleStore() {
      if (!store.hasModule(this.name)) {
        const newStore = merge(cloneDeep(this.copy), cloneDeep(this.copyChanges));
        store.registerModule(this.name, newStore);
        store.commit(`${this.name}/RESET_STATE`);
      }
      if (store.hasModule(this.name)) this.loaded = true;
    },
  },
  created() {
    this.handleStore();
  },
  destroyed() {
    if (store.hasModule(this.name) && this.isTemporary) {
      this.loaded = false;
      store.unregisterModule(this.name);
    }
  },
};
</script>

<style>

</style>
